import { ValueOf } from 'components/common/types/ValueOf';

type ThemeStyle = {
  iconSize?: string;
  iconUnchecked: string;
  iconChecked: string;
  dot?: string;
  dotUnchecked?: string;
  dotChecked?: string;
  dotCheckedPosition?: string;
  dotUncheckedPosition?: string;
};

export const ToggleTheme = {
  DARK: 'dark',
  LIGHT: 'light',
  SMALL_LIGHT: 'smallLight',
  PINK: 'pink',
};

export const themeStyles: { [theme: ValueOf<typeof ToggleTheme>]: ThemeStyle } = {
  [ToggleTheme.LIGHT]: {
    dot: 'bg-neutral-50',
    iconChecked: 'bg-primary-800',
    iconUnchecked: 'bg-neutral-800',
  },
  [ToggleTheme.DARK]: {
    iconChecked: 'bg-neutral-200',
    iconUnchecked: 'bg-primary-800',
    dotChecked: 'bg-primary-800',
    dotUnchecked: 'bg-neutral-50',
  },
  [ToggleTheme.SMALL_LIGHT]: {
    iconSize: 'w-6 h-3',
    iconChecked: 'bg-primary-700',
    iconUnchecked: 'bg-neutral-800',
    dot: 'w-[10px] h-[10px] bg-neutral-50',
    dotCheckedPosition: 'left-[calc(100%-0.375rem)]',
    dotUncheckedPosition: 'left-[0.375rem]',
  },
  [ToggleTheme.PINK]: {
    dot: 'bg-neutral-50',
    iconChecked: 'bg-pink-600',
    iconUnchecked: 'bg-neutral-800',
  },
};
